import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo, MensajeCapcha } from "../../mensajes2";

import { formatMoneda } from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import useTableFijo from "../../useTableFijo";
import TablaRegistro from "./tablaRegistro";
import { Motivo } from "./modalMotivo";
import TablaDeudapp from "./tablaDeudasPP";
import Tablahtpp from "./tablaHistoryPP";
import { Dimmer } from "../../spinner";

const headCells = [
  {
    id: "idactividad",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION DE PUBLICIDAD COMERCIAL",
    width: "250px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "alicuota",
    label: "ALICUOTA",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "minimo",
    label: "AREA/UNID",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "alicuota",
    label: "MONTO A PAGAR",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "alicuota",
    label: "CANCELAR",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

export const AgregarPP = (props) => {
  const btnCancela = useRef();
  const txtStatus = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [factorCambio, setFactorCambio] = useState(0);

  const [select, setSelect] = useState("0");
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [visible, setVisible] = useState(false);
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [anio, setAnio] = useState([]);
  const txtEstatusMotivo = useRef();
  const [cargar, setCargar] = useState(false);

  const [values, setValues] = useState({
    idcomercio: "",
    ritm: "",
    nombre: "",
    direccion: "",
    motivopublicidad: "",
    telefono: "",
    status: "",
    statuspublicidad: "",
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const onChange = (event) => {
    if (event.target.name === "motivopublicidad") {
      event.target.value = event.target.value.toUpperCase();
    }

    if (event.target.name === "statuspublicidad") {
      let selector = txtStatus.current.value;
      if (event.target.value === "0") {
        setSelect(selector);

        setMensajesino({
          mostrar: false,
          titulo: "Notificación",
          texto: "Esta Segudo de Cambiar el Estatus a Inactivo?",
          icono: "informacion",
        });
      } else if (event.target.value === "1") {
        setSelect(selector);

        setMensajesino({
          mostrar: false,
          titulo: "Notificación",
          texto: "Esta Segudo de Cambiar el Estatus a Activo?",
          icono: "informacion",
        });
      } else {
        setMostrar1(false);
        handleCloseNoo();
      }
    }

    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const cerrarModal = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    props.onHideCancela();
  };

  const Actualizar = (idcomercio) => {
    let endpoint = `${op.conexion}/api/publicidad/actmotivo/${idcomercio}`;
    let body;
    setActivate(true);

    body = {
      idcomercio: parseInt(values.idcomercio),
      statuspublicidad: parseInt(txtStatus.current.value === "0" ? "0" : "1"),
      motivopublicidad: null,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.comercio.idcomercio > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Motivo Anulado Correctamente",
              icono: "informacion",
            });
          } else {
            setMensaje({
              mostrar: true,
              titulo: "ERROR",
              texto: "Error al Registrar el Motivo",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const handleCloseNoo = () => {
    setMostrar3(false);
  };

  const handleCloseSi = () => {
    if (msg === "Esta Segudo de Cambiar el Estatus a Activo?") {
      Actualizar(props.comercio.idcomercio);
    } else {
      setMostrar4(true);
    }
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
    if (txtStatus.current.value === "0") {
      setSelect(1);
      values.statuspublicidad = 1;
    } else {
      setSelect("0");
      values.statuspublicidad = 0;
    }
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg == "Motivo Anulado Correctamente" ||
      msg == "Error al Registrar el Motivo"
    ) {
      props.onHideRenderizar(props.comercio.idcomercio);
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setHabilitadoNR(false);
    blanquear();
    props.onHideCancela();
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    var nanio = [];
    var aini = parseInt(obj.anioactu) - 23;
    var afin = parseInt(obj.anioactu);
    for (let i = 1; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });
    }
    setAnio(nanio);
    if (props.operacion) {
      setOperacion(props.operacion);
    }
  }, []);

  const blanquear = () => {
    setMostrar(false);
    setMostrar3(false);
    setMostrar4(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setValues({
      idcomercio: "",
      ritm: "",
      nombre: "",
      direccion: "",
      motivopublicidad: "",
      telefono: "",
      status: "",
      statuspublicidad: "",
    });
  };

  const cerrarModalActualizar = () => {
    setMostrar4(false);
  };

  const render = () => {
    props.onHideRenderizar(props.comercio.idcomercio);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setVisible(false);
        setFactorCambio(props.factorCambio);
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setCargar(true);
        if (props.operacion !== 1) {
          setValues(props.comercio);

          if (props.comercio.statuspublicidad === 0) {
            setSelect("0");
          } else {
            setSelect("1");
          }
        }
      }}
    >
      <Modal.Header className="azulGradiant" style={{ height: "40px" }}>
        <div style={{ color: "#fff", fontSize: 20 }}>
          {operacion === 1
            ? "Agregar Propaganda y Publicidad."
            : operacion === 2
              ? "Registro Contribuyente Propaganda y Publicidad."
              : operacion === 3
                ? "Eliminar Propaganda y Publicidad."
                : "Consultar Propaganda y Publicidad."}
        </div>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#ffffff", color: "" }}>
        <Motivo
          show={mostrar4}
          comercio={props.comercio}
          onHideRenderizarp={render}
          onHideCancela={cerrarModalActualizar}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />

        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <div className="row rounded mx-auto px-0">
            <div
              className="container col-md-12 mx-auto px-0"
              style={{ backgroundColor: "", color: "" }}
            >
              <div className="mx-auto">
                <table
                  className="table table-sm table-bordered"
                  style={{ fontSize: "12px", margin: 0 }}
                >
                  <tbody>
                    <tr>
                      <td className="col-md-2 col-2">
                        <span className="fw-bold">Código: &nbsp; </span>
                        <label for="colFormLabelSm" className="form-label">
                          {values && values.idcomercio}
                        </label>
                      </td>
                      <td className="col-md-3 col-3">
                        <span className="fw-bold"> Nº de RITM: &nbsp; </span>
                        <label for="colFormLabelSm" className="form-label">
                          {values && values.ritm}
                        </label>
                      </td>
                      <td className="col-md-2 col-2">
                        <span className="fw-bold"> RIF:&nbsp; </span>
                        <label for="colFormLabelSm" className="form-label">
                          {values && values.rif
                            ? values.rif !== null
                              ? values.rif.trim()
                              : ""
                            : ""}
                        </label>
                      </td>
                      <td className="col-md-3 col-3">
                        <div className="input-group input-group-sm mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">Estatus: </span>
                          </div>
                          <select
                            disabled={
                              operacion === 4 || operacion === 3
                                ? true
                                : deshabilitado
                            }
                            ref={txtStatus}
                            className="form-control text-uppercase"
                            id="inputStatus"
                            name="statuspublicidad"
                            value={values.statuspublicidad}
                            onChange={onChange}
                          >
                            <option value={0}>INACTIVO</option>
                            <option value={1}>ACTIVO</option>
                          </select>
                        </div>
                      </td>
                      <td className="col-md-2 col-2">
                        <span className="fw-bold"> N° Telefono:&nbsp; </span>
                        <label for="colFormLabelSm" className="form-label">
                          {values && values.telefono
                            ? values.telefono !== null
                              ? values.telefono.trim()
                              : ""
                            : ""}
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="container row col-md-12 mx-auto px-0">
              <table
                className="table table-sm v-100 table-bordered"
                style={{ fontSize: "12px", margin: 0 }}
              >
                <tbody>
                  <tr>
                    <td>
                      <span className="fw-bold">
                        {" "}
                        Denominación Comercial:&nbsp;{" "}
                      </span>
                      <label for="colFormLabelSm" className="form-label">
                        {values && values.nombre
                          ? values.nombre !== null
                            ? values.nombre.trim()
                            : ""
                          : ""}
                      </label>
                    </td>
                    <td>
                      <span className="fw-bold"> Dirección:&nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {values && values.direccion
                          ? values.direccion !== null
                            ? values.direccion.trim()
                            : ""
                          : ""}
                      </label>
                    </td>

                    <td className="fw-bold">
                      {"Valor Euro €: " +
                        formatMoneda(
                          factorCambio
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2,
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">
                      {select === "0" ? (
                        <td className="list-group list-group-horizontal-sm">
                          <li className="list-group-item col-md-12">
                            <span className="fw-bold">
                              {" "}
                              Motivo del Estatus INACTIVO:&nbsp;{" "}
                            </span>
                            <input
                              type="text"
                              ref={txtEstatusMotivo}
                              className="form-control text-uppercase"
                              name="motivopublicidad"
                              defaultValue={
                                props.comercio &&
                                props.comercio.motivopublicidad !== null
                                  ? props.comercio.motivopublicidad.trim()
                                  : ""
                              }
                              onChange={onChange}
                              id="inputDirecpropiet"
                              disabled
                              readonly
                            />
                          </li>
                        </td>
                      ) : select === "1" ? (
                        <ul className="list-group list-group-horizontal-sm"></ul>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                  <h5 className="fw-bold p-1 m-1">Datos del Responsable</h5>
                  <tr>
                    <td colspan="4">
                      <table
                        className="table table-sm v-100 table-secondary table-bordered"
                        style={{ fontSize: "12px" }}
                      >
                        <tbody>
                          <tr>
                            <td>
                              <span className="fw-bold"> Nombres:&nbsp; </span>
                              <label
                                for="colFormLabelSm"
                                className="form-label"
                              >
                                {props.persona && props.persona.nombres !== null
                                  ? props.persona.nombres.trim()
                                  : ""}
                              </label>
                            </td>
                            <td>
                              <span className="fw-bold">
                                {" "}
                                Apellidos:&nbsp;{" "}
                              </span>
                              <label
                                for="colFormLabelSm"
                                className="form-label"
                              >
                                {props.persona &&
                                props.persona.apellidos !== null
                                  ? props.persona.apellidos.trim()
                                  : ""}
                              </label>
                            </td>
                            <td>
                              <span className="fw-bold"> Cédula:&nbsp; </span>
                              <label
                                for="colFormLabelSm"
                                className="form-label"
                              >
                                {props.persona && props.persona.cedula !== null
                                  ? props.persona.cedula
                                  : ""}
                              </label>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span className="fw-bold">
                                {" "}
                                Dirección:&nbsp;{" "}
                              </span>
                              <label
                                for="colFormLabelSm"
                                className="form-label"
                              >
                                {props.persona &&
                                props.persona.direccion !== null
                                  ? props.persona.direccion.trim()
                                  : ""}
                              </label>
                            </td>
                            <td>
                              <span className="fw-bold">
                                {" "}
                                N° Telefono:&nbsp;{" "}
                              </span>
                              <label
                                for="colFormLabelSm"
                                className="form-label"
                              >
                                {props.persona && props.persona.tlf1 !== null
                                  ? props.persona.tlf1
                                  : ""}
                              </label>
                            </td>
                            <td>
                              <span className="fw-bold">
                                {" "}
                                N° Celular:&nbsp;{" "}
                              </span>
                              <label
                                for="colFormLabelSm"
                                className="form-label"
                              >
                                {props.persona && props.persona.tlf2 !== null
                                  ? props.persona.tlf2
                                  : ""}
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <ul className="nav" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link active bg-blue-100 text-light"
                id="datos-tab"
                data-bs-toggle="tab"
                data-bs-target="#datos"
                type="button"
                role="tab"
                aria-controls="datos"
                aria-selected="true"
              >
                Datos Generales
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link bg-blue-200 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Deudas del Contribuyente
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className=" rounded nav-link bg-blue-300 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="historico-tab"
                data-bs-toggle="tab"
                data-bs-target="#historico"
                type="button"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Historico de Pagos
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="datos"
              role="tabpanel"
              aria-labelledby="datos-tab"
            >
              <TablaRegistro
                idcomercio={props.comercio ? props.comercio.idcomercio : 0}
                status={props.comercio ? props.comercio.statuspublicidad : 1}
                nombre={props.comercio ? props.comercio.nombre : ""}
                cargar={cargar}
                factorCambio={factorCambio}
              />
            </div>
            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <TablaDeudapp
                tabdeuda={props.deuda}
                total={props.total}
                valorpetro={props.valorpetro}
                idcomercio={props.comercio && props.comercio.idcomercio}
                cargar={cargar}
              />
            </div>
            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="historico-tab"
            >
              <Tablahtpp
                tabhistoy={props.history}
                total={props.total}
                idcomercio={props.comercio && props.comercio.idcomercio}
                cargar={cargar}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
